<div class="cellWrapper">
    @if (buttonDisplayHandler()) {
        @for (button of buttons(); track button; let index = $index) {
            @if (button.showLoader) {
                <div class="spinner"></div>
            } @else {
                <button
                    class="button transparent hasIcon large"
                    [class.spinning]="button.showLoader"
                    type="button"
                    title="{{ button.label | translate }}"
                    (click)="buttonClickHandler(index)"
                    [disabled]="button.disabled"
                >
                    <i class="far" [ngClass]="'fa-' + button.icon"></i>
                </button>
            }
        }
    }
</div>
